import React from 'react';
import { SystemIcon } from '@storeblocks/icon';
import { ChipBase, Input, Label } from './styled';
function Chip({ id, label, onChange, checked, disabled, value, type, name, inputProps, labelProps, }) {
    function renderCheckIcon() {
        if (type === 'filter' && checked) {
            return (React.createElement(SystemIcon, { name: "check", "aria-label": "checked", size: 16, mr: "8px" }));
        }
        return null;
    }
    function renderCrossIcon() {
        if (type === 'input' && checked) {
            return (React.createElement(SystemIcon, { name: "remove-circle-filled", "aria-label": "dismiss", size: 16, ml: "8px" }));
        }
        return null;
    }
    const labelId = `${id}-label-text`;
    return (React.createElement(Label, Object.assign({ role: "presentation" }, labelProps),
        React.createElement(Input, Object.assign({ "aria-labelledby": labelId, id: id, name: name, value: value, type: type === 'choice' ? 'radio' : 'checkbox', checked: checked, onChange: onChange, disabled: disabled }, inputProps)),
        React.createElement(ChipBase, { id: labelId, "aria-hidden": "true", checked: checked, disabled: disabled, type: type },
            renderCheckIcon(),
            label,
            renderCrossIcon())));
}
export default Chip;
